module.exports = __webpack_public_path__ + "static/media/ministry_edit_icon.22b9c054.svg";